module.exports = __webpack_public_path__ + "static/media/active_event_banner.1267b84d.png";